require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./wod-2017-11-18.json") })
        }
      }, "path---wod-2017-11-18");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---wod-2017-11-18!./.cache/json/wod-2017-11-18.json
// module id = 467
// module chunks = 231608221292675